"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeAllyStakingFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TimeAllyStakingFactory = /** @class */ (function (_super) {
    __extends(TimeAllyStakingFactory, _super);
    function TimeAllyStakingFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TimeAllyStakingFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    TimeAllyStakingFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    TimeAllyStakingFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TimeAllyStakingFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TimeAllyStakingFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TimeAllyStakingFactory;
}(contracts_1.ContractFactory));
exports.TimeAllyStakingFactory = TimeAllyStakingFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'enum ITimeAllyManager.RewardType',
                name: 'rewardType',
                type: 'uint8',
            },
        ],
        name: 'Claim',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'platform',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'extraData',
                type: 'bytes',
            },
        ],
        name: 'Delegate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'enum TimeAllyStaking.DestroyReason',
                name: 'destroyReason',
                type: 'uint8',
            },
        ],
        name: 'Destroy',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'benefactor',
                type: 'address',
            },
        ],
        name: 'IssTimeIncrease',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'int256',
                name: 'amount',
                type: 'int256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'benefactor',
                type: 'address',
            },
        ],
        name: 'Topup',
        type: 'event',
    },
    {
        inputs: [],
        name: 'SECONDS_IN_MONTH',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_platform',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: '_extraData',
                type: 'bytes',
            },
            {
                internalType: 'uint32[]',
                name: '_months',
                type: 'uint32[]',
            },
        ],
        name: 'delegate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'endMonth',
        outputs: [
            {
                internalType: 'uint32',
                name: '',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'extend',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getDelegation',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getIssTimeInterest',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getMonthlyReward',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getPrincipalAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_month',
                type: 'uint256',
            },
        ],
        name: 'getSplitFee',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: '_destroy',
                type: 'bool',
            },
        ],
        name: 'getTotalIssTime',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'hasDelegations',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_increaseValue',
                type: 'uint256',
            },
        ],
        name: 'increaseIssTime',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner',
                type: 'address',
            },
            {
                internalType: 'uint32',
                name: '_defaultMonths',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: '_initialIssTimeLimit',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_nrtManager',
                type: 'address',
            },
            {
                internalType: 'bool[]',
                name: '_claimedMonths',
                type: 'bool[]',
            },
        ],
        name: 'init',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isDestroyed',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'isMonthClaimed',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'isMonthDelegated',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'issTimeLimit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'issTimeTakenValue',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'issTimeTimestamp',
        outputs: [
            {
                internalType: 'uint48',
                name: '',
                type: 'uint48',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lastIssTimeMonth',
        outputs: [
            {
                internalType: 'uint32',
                name: '',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_masterStaking',
                type: 'address',
            },
        ],
        name: 'mergeIn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nextMonthPrincipalAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'prepaidFallback',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'principal',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_childOwner',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_childIssTimeLimit',
                type: 'uint256',
            },
        ],
        name: 'receiveMerge',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'reportIssTime',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'split',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_value',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_destroy',
                type: 'bool',
            },
        ],
        name: 'startIssTime',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'startMonth',
        outputs: [
            {
                internalType: 'uint32',
                name: '',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'submitIssTime',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timestamp',
        outputs: [
            {
                internalType: 'uint48',
                name: '',
                type: 'uint48',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32[]',
                name: '_months',
                type: 'uint32[]',
            },
            {
                internalType: 'enum ITimeAllyManager.RewardType',
                name: '_rewardType',
                type: 'uint8',
            },
        ],
        name: 'withdrawMonthlyNRT',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=TimeAllyStakingFactory.js.map